export default __webpack_public_path__ + "static/media/torri_logo.a15584a7.png";